// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"85744cbb","77":"dada71d5","131":"6fa7245a","144":"15000278","198":"76c95659","253":"f772d3f3","417":"8d531c9d","543":"6a4e578f","635":"48b7148b","694":"080f0c19","724":"06332aad","859":"5872e346","872":"740ad624","883":"bf7af0e7"}[chunkId] + ".chunk.js";
};